import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
// Font Inter serwowany z naszego builda (subset latin-ext = polskie znaki), zamiast
// @import z fonts.googleapis.com. Wagi odpowiadaja tym, ktorych uzywa App.css.
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import loginBackground from './assets/images/login-background.png';
import axios from 'axios';
import { installTrainingTelemetry } from './trainingTelemetry';

installTrainingTelemetry(axios);

const AppWrapper = () => {
  React.useEffect(() => {
    // Derive backend origin from REACT_APP_API_BASE_URL
    // e.g. https://pkpopo101.innerweb.net/szkolenia/webapi/training/ → https://pkpopo101.innerweb.net
    const apiUrl = process.env.REACT_APP_API_BASE_URL || '';
    let backendOrigin = '';
    try {
      backendOrigin = new URL(apiUrl).origin;
    } catch {
      // fallback: same origin
      backendOrigin = window.location.origin;
    }

    const bgUrl = `${backendOrigin}/background?theme=light`;

    // Try to load background from backend; fall back to bundled static image
    const img = new Image();
    img.onload = () => {
      document.documentElement.style.setProperty(
        '--background-image-url',
        `url(${bgUrl})`
      );
    };
    img.onerror = () => {
      // Fallback to bundled static background
      document.documentElement.style.setProperty(
        '--background-image-url',
        `url(${loginBackground})`
      );
    };
    img.src = bgUrl;
  }, []);

  return <App />;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppWrapper />
  </React.StrictMode>
);

reportWebVitals();
